/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weak_Fond_Hare_DineInputs */

const en_weak_fond_hare_dine = /** @type {(inputs: Weak_Fond_Hare_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to add user`)
};

const de_weak_fond_hare_dine = /** @type {(inputs: Weak_Fond_Hare_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Failed to add user" |
*
* @param {Weak_Fond_Hare_DineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const weak_fond_hare_dine = /** @type {((inputs?: Weak_Fond_Hare_DineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weak_Fond_Hare_DineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_weak_fond_hare_dine(inputs)
	return de_weak_fond_hare_dine(inputs)
});